import { render, staticRenderFns } from "./AccessInterfaceHeader.vue?vue&type=template&id=5497098f&"
import script from "./AccessInterfaceHeader.vue?vue&type=script&lang=ts&"
export * from "./AccessInterfaceHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AccessInterfaceHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports